export default __webpack_public_path__ + "static/media/3098.ee5b8164.jpg";